/**
 * Index format.
 */
export enum IndexFormat {
  /** 8 bit */
  UInt8,
  /** 16 bit */
  UInt16,
  /** 32 bit */
  UInt32
}
